import { QUALIFICATION_STATUS } from "../../../../../common/enums/incentive-enums";
import type { HatFppModalData } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";
import type { FoundersPlatinumProgressResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";

export const mapHatModalToFppResponse = (modal: HatFppModalData): FoundersPlatinumProgressResponse => ({
  SpMonthsRequirement: {
    MonthsRequired: modal.spMonthsRequirement.MonthsRequired,
    MonthsAchieved: modal.spMonthsRequirement.MonthsAchieved,
    MonthsNeeded: modal.spMonthsRequirement.MonthsNeeded,
    MonthsQualificationStatus: modal.spMonthsRequirement.MonthsQualificationStatus as QUALIFICATION_STATUS,
    Qualified: modal.spMonthsRequirement.Qualified,
  },
  GpvRequirement: {
    MonthsRequired: modal.gpvRequirement.monthsRequired,
    MonthsAchieved: modal.gpvRequirement.monthsAchieved,
    MonthsNeeded: modal.gpvRequirement.monthsNeeded,
    AnnualGpvRequired: modal.gpvRequirement.annualGpvRequired.Actual,
    AnnualGpvEarned: modal.gpvRequirement.annualGpvEarned.Actual,
    AnnualGpvNeeded: modal.gpvRequirement.annualGpvNeeded.Actual,
    MonthsQualificationStatus: modal.gpvRequirement.monthsQualificationStatus as QUALIFICATION_STATUS,
    GpvQualificationStatus: modal.gpvRequirement.gpvQualificationStatus as QUALIFICATION_STATUS,
    RequirementQualificationStatus: modal.gpvRequirement.requirementQualificationStatus as QUALIFICATION_STATUS,
  },
  VepvRequirement: {
    MonthsRequired: modal.vepvRequirement.monthsRequired,
    MonthsAchieved: modal.vepvRequirement.monthsAchieved,
    MonthsNeeded: modal.vepvRequirement.monthsNeeded,
    AnnualVepvRequired: modal.vepvRequirement.annualVepvRequired.Actual,
    AnnualVepvEarned: modal.vepvRequirement.annualVepvEarned.Actual,
    AnnualVepvNeeded: modal.vepvRequirement.annualVepvNeeded.Actual,
    MonthsQualificationStatus: modal.vepvRequirement.monthsQualificationStatus as QUALIFICATION_STATUS,
    VepvQualificationStatus: modal.vepvRequirement.vepvQualificationStatus as QUALIFICATION_STATUS,
    RequirementQualificationStatus: modal.vepvRequirement.requirementQualificationStatus as QUALIFICATION_STATUS,
  },
  CallResult: [],
  Error: "",
});
